export default [
  {
    title: "수직 부재",
    list: [
      {
        content: "크레인 해체 전 전도방지 조치 확인",
        isChecked: "",
      },
      {
        content: "전도방지 지그 상태 확인",
        isChecked: "",
      },
      {
        content: "작업 전후 청소 및 정리정돈",
        isChecked: "",
      },
    ],
  },
  {
    title: "탱크(Tank) 내",
    list: [
      {
        content: "조명상태 확인",
        isChecked: "",
      },
      {
        content: "환기 팬(Fan) 가동 후 작업",
        isChecked: "",
      },
      {
        content: "이면(하부) 확인 후 작업",
        isChecked: "",
      },
      {
        content: "사다리 이동 시 물건을 들고 이동 금지",
        isChecked: "",
      },
      {
        content: "휴식시간 및 미사용 절단기 토치 분리",
        isChecked: "",
      },
      {
        content: "CO2 가스 연결 상태 확인",
        isChecked: "",
      },
      {
        content: "작업 전후 청소 및 정리정돈",
        isChecked: "",
      },
    ],
  },
  {
    title: "고소차, 곤돌라",
    list: [
      {
        content: "장비 탑승 시 안전벨트 착용",
        isChecked: "",
      },
      {
        content: "곤돌라 생명줄 연결고리 상태 확인",
        isChecked: "",
      },
      {
        content: "곤돌라 권과방지장치 점검",
        isChecked: "",
      },
      {
        content: "고소차 브레이크 상태 확인",
        isChecked: "",
      },
      {
        content: "고소차 이동 시 2인 이상 탑승 금지",
        isChecked: "",
      },
      {
        content: "하부 인하 물질 확인",
        isChecked: "",
      },
      {
        content: "장비 바스켓 내 청소 및 정리정돈",
        isChecked: "",
      },
    ],
  },
];
